import { Component } from '@angular/core';

@Component({
    selector: 'kx-500-component',
    templateUrl: '500.component.html',
    standalone: false
})
export class P500Component {

  constructor() { }

}
